import { render } from "./ProjectStat.vue?vue&type=template&id=5c1c72b6&scoped=true"
import script from "./ProjectStat.vue?vue&type=script&lang=js"
export * from "./ProjectStat.vue?vue&type=script&lang=js"

import "./ProjectStat.vue?vue&type=style&index=0&id=5c1c72b6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c1c72b6"]])

export default __exports__